module.exports = __webpack_public_path__ + "static/media/expense.3e5ee9b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/expense.svg
// module id = 2153
// module chunks = 0